export function getRequestVerificationToken() {
    const requestVerificationToken = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement;
    if (requestVerificationToken == null) {
        alert("Det finns ingen RequestVerificationToken");
        return;
    }

    return requestVerificationToken.value;
}
